import { createApi } from '@reduxjs/toolkit/query/react';

import { IApiResponse } from '../types/IApiResponse';
import baseQueryCheckAccessToken from './baseQueryCheckAccessToken';

export const onbordingAPI = createApi({
  reducerPath: 'onbordingAPI',
  baseQuery: baseQueryCheckAccessToken,
  tagTypes: ['Onbording'],
  endpoints: (build) => ({
    getStatus: build.query<
      IApiResponse<{ hasPoint: boolean; demoDataCreated: boolean }>,
      null
    >({
      query: () => ({
        url: `/onboarding/status`,
      }),
      providesTags: () => ['Onbording'],
    }),
    completePointSetup: build.mutation<IApiResponse<null>, null>({
      query: () => ({
        url: `/onboarding/complete-point-setup`,
        method: 'POST',
      }),
      invalidatesTags: () => ['Onbording'],
    }),
  }),
});
